import { db } from "@/firebaseConfig";

const zClosuresCollection = db.collection("z_closures");

const saveZclousure = async (id, data) => {
  zClosuresCollection
    .doc(id.toString())
    .set(data)
    .then(() => {
      console.log("Zclousure successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateZclousure = async (id, data) => {
  zClosuresCollection
    .doc(id.toString())
    .update(data)
    .then(() => {
      console.log("Zclousure successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteZclousure = async id => {
  zClosuresCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Zclousure successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getZclousureById = async id => {
  return zClosuresCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getZClousureByRangeOfDates = async (start, end) => {
  return zClosuresCollection
    .where("opened_on", ">=", start)
    .where("opened_on", "<=", end)
    .get()
    .then(querySnapshot => {
      let result = [];
      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });
      return result.filter(res => res.closed_on !== null);
    })
    .catch(error => {
      throw error;
    });
};

const getOneZClousureByRangeOfDates = async (start, end) => {
  return zClosuresCollection
    .where("opened_on", ">=", start)
    .where("opened_on", "<=", end)
    .orderBy("opened_on")
    .limit(1)
    .get()
    .then(querySnapshot => {
      let result = [];
      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });
      return result;
    })
    .catch(error => {
      throw error;
    });
};

const getAllZClousureByRangeOfDates = async (start, end) => {
  return zClosuresCollection
    .where("opened_on", ">=", start)
    .where("opened_on", "<=", end)
    .get()
    .then(querySnapshot => {
      let result = [];
      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });
      return result;
    })
    .catch(error => {
      throw error;
    });
};

const getZClousureByDate = async start => {
  return zClosuresCollection
    .where("opened_on", ">=", start)
    .get()
    .then(querySnapshot => {
      let result = [];
      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });
      return result;
    })
    .catch(error => {
      throw error;
    });
};

const getLastZclousure = async () => {
  return zClosuresCollection
    .orderBy("opened_on", "desc")
    .limit(1)
    .get()
    .then(querySnapshot => {
      let result = [];
      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });
      return result;
    })
    .catch(error => {
      throw error;
    });
};

const getLastZclousureOpened = async () => {
  return await zClosuresCollection
    .where("closed_on", "==", null)
    .orderBy("opened_on", "desc")
    .limit(1)
    .get();
};

const getLastZclousureClosed = async () => {
  return await zClosuresCollection
    .where("closed_on", "!=", null)
    .orderBy("closed_on", "desc")
    .limit(1)
    .get();
};

export {
  zClosuresCollection,
  saveZclousure,
  updateZclousure,
  deleteZclousure,
  getZclousureById,
  getZClousureByRangeOfDates,
  getOneZClousureByRangeOfDates,
  getLastZclousure,
  getLastZclousureOpened,
  getLastZclousureClosed,
  getAllZClousureByRangeOfDates,
  getZClousureByDate
};
